var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-overlay',{attrs:{"value":_vm.visible,"color":_vm.color,"opacity":_vm.opacity}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"48","color":_vm.spinnerColor}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }